// @generated by bzl gen
// @generated by protoc-gen-es v0.2.1 with parameter "target=ts"
// @generated from file dropbox/proto/context_engine/ml_capabilities_common_clone.proto (package context_engine, syntax proto3)
/* eslint-disable */
/* @ts-nocheck */

import type {
  BinaryReadOptions,
  FieldList,
  JsonReadOptions,
  JsonValue,
  PartialMessage,
  PlainMessage,
} from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message context_engine.ChatContent
 */
export class ChatContent extends Message<ChatContent> {
  /**
   * @generated from field: string text = 1;
   */
  text = "";

  /**
   * List of messages in json format.
   *
   * @generated from field: repeated string content_dicts = 2;
   */
  contentDicts: string[] = [];

  constructor(data?: PartialMessage<ChatContent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ChatContent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 2,
      name: "content_dicts",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      repeated: true,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ChatContent {
    return new ChatContent().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ChatContent {
    return new ChatContent().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ChatContent {
    return new ChatContent().fromJsonString(jsonString, options);
  }

  static equals(
    a: ChatContent | PlainMessage<ChatContent> | undefined,
    b: ChatContent | PlainMessage<ChatContent> | undefined,
  ): boolean {
    return proto3.util.equals(ChatContent, a, b);
  }
}

/**
 * System messages provide context to the assistant and are not user visible.
 *
 * @generated from message context_engine.SystemMessage
 */
export class SystemMessage extends Message<SystemMessage> {
  /**
   * @generated from field: context_engine.ChatContent content = 1;
   */
  content?: ChatContent;

  constructor(data?: PartialMessage<SystemMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.SystemMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "content", kind: "message", T: ChatContent },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): SystemMessage {
    return new SystemMessage().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): SystemMessage {
    return new SystemMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): SystemMessage {
    return new SystemMessage().fromJsonString(jsonString, options);
  }

  static equals(
    a: SystemMessage | PlainMessage<SystemMessage> | undefined,
    b: SystemMessage | PlainMessage<SystemMessage> | undefined,
  ): boolean {
    return proto3.util.equals(SystemMessage, a, b);
  }
}

/**
 * Messsage from the user prompting the system, typically human.
 *
 * @generated from message context_engine.UserMessage
 */
export class UserMessage extends Message<UserMessage> {
  /**
   * @generated from field: context_engine.ChatContent content = 1;
   */
  content?: ChatContent;

  constructor(data?: PartialMessage<UserMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.UserMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "content", kind: "message", T: ChatContent },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): UserMessage {
    return new UserMessage().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): UserMessage {
    return new UserMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): UserMessage {
    return new UserMessage().fromJsonString(jsonString, options);
  }

  static equals(
    a: UserMessage | PlainMessage<UserMessage> | undefined,
    b: UserMessage | PlainMessage<UserMessage> | undefined,
  ): boolean {
    return proto3.util.equals(UserMessage, a, b);
  }
}

/**
 * @generated from message context_engine.FunctionCall
 */
export class FunctionCall extends Message<FunctionCall> {
  /**
   * The name of the function to call.
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * The arguments to call the function with, as generated by the model in JSON format.
   * Note that the model does not always generate valid JSON, and may hallucinate parameters not
   * defined by your function schema. Validate the arguments in your code before calling your function.
   *
   * @generated from field: string arguments = 2;
   */
  arguments = "";

  constructor(data?: PartialMessage<FunctionCall>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.FunctionCall";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "arguments", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): FunctionCall {
    return new FunctionCall().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): FunctionCall {
    return new FunctionCall().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): FunctionCall {
    return new FunctionCall().fromJsonString(jsonString, options);
  }

  static equals(
    a: FunctionCall | PlainMessage<FunctionCall> | undefined,
    b: FunctionCall | PlainMessage<FunctionCall> | undefined,
  ): boolean {
    return proto3.util.equals(FunctionCall, a, b);
  }
}

/**
 * @generated from message context_engine.ToolCall
 */
export class ToolCall extends Message<ToolCall> {
  /**
   * The ID of the tool call
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * The type of the tool. Currently only `function` is supported.
   *
   * @generated from field: string type = 2;
   */
  type = "";

  /**
   * The function that the model suggests is called.
   *
   * @generated from field: context_engine.FunctionCall function = 3;
   */
  function?: FunctionCall;

  constructor(data?: PartialMessage<ToolCall>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ToolCall";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "function", kind: "message", T: FunctionCall },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ToolCall {
    return new ToolCall().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ToolCall {
    return new ToolCall().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ToolCall {
    return new ToolCall().fromJsonString(jsonString, options);
  }

  static equals(
    a: ToolCall | PlainMessage<ToolCall> | undefined,
    b: ToolCall | PlainMessage<ToolCall> | undefined,
  ): boolean {
    return proto3.util.equals(ToolCall, a, b);
  }
}

/**
 * Message generated by the AI assistant.
 *
 * @generated from message context_engine.AssistantMessage
 */
export class AssistantMessage extends Message<AssistantMessage> {
  /**
   * @generated from field: context_engine.ChatContent content = 1;
   */
  content?: ChatContent;

  /**
   * If provided, tool calls associated with the message.
   *
   * @generated from field: repeated context_engine.ToolCall tool_calls = 2;
   */
  toolCalls: ToolCall[] = [];

  constructor(data?: PartialMessage<AssistantMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.AssistantMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "content", kind: "message", T: ChatContent },
    { no: 2, name: "tool_calls", kind: "message", T: ToolCall, repeated: true },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): AssistantMessage {
    return new AssistantMessage().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): AssistantMessage {
    return new AssistantMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): AssistantMessage {
    return new AssistantMessage().fromJsonString(jsonString, options);
  }

  static equals(
    a: AssistantMessage | PlainMessage<AssistantMessage> | undefined,
    b: AssistantMessage | PlainMessage<AssistantMessage> | undefined,
  ): boolean {
    return proto3.util.equals(AssistantMessage, a, b);
  }
}

/**
 * The response of a tool call.
 *
 * @generated from message context_engine.ToolMessage
 */
export class ToolMessage extends Message<ToolMessage> {
  /**
   * @generated from field: context_engine.ChatContent content = 1;
   */
  content?: ChatContent;

  /**
   * Tool call that this message is responding to.
   *
   * @generated from field: string tool_call_id = 2;
   */
  toolCallId = "";

  constructor(data?: PartialMessage<ToolMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ToolMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "content", kind: "message", T: ChatContent },
    {
      no: 2,
      name: "tool_call_id",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ToolMessage {
    return new ToolMessage().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ToolMessage {
    return new ToolMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ToolMessage {
    return new ToolMessage().fromJsonString(jsonString, options);
  }

  static equals(
    a: ToolMessage | PlainMessage<ToolMessage> | undefined,
    b: ToolMessage | PlainMessage<ToolMessage> | undefined,
  ): boolean {
    return proto3.util.equals(ToolMessage, a, b);
  }
}

/**
 * @generated from message context_engine.ChatMessage
 */
export class ChatMessage extends Message<ChatMessage> {
  /**
   * @generated from oneof context_engine.ChatMessage.message_type
   */
  messageType:
    | {
        /**
         * @generated from field: context_engine.SystemMessage system_message = 1;
         */
        value: SystemMessage;
        case: "systemMessage";
      }
    | {
        /**
         * @generated from field: context_engine.UserMessage user_message = 2;
         */
        value: UserMessage;
        case: "userMessage";
      }
    | {
        /**
         * @generated from field: context_engine.AssistantMessage assistant_message = 3;
         */
        value: AssistantMessage;
        case: "assistantMessage";
      }
    | {
        /**
         * @generated from field: context_engine.ToolMessage tool_message = 4;
         */
        value: ToolMessage;
        case: "toolMessage";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<ChatMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ChatMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "system_message",
      kind: "message",
      T: SystemMessage,
      oneof: "message_type",
    },
    {
      no: 2,
      name: "user_message",
      kind: "message",
      T: UserMessage,
      oneof: "message_type",
    },
    {
      no: 3,
      name: "assistant_message",
      kind: "message",
      T: AssistantMessage,
      oneof: "message_type",
    },
    {
      no: 4,
      name: "tool_message",
      kind: "message",
      T: ToolMessage,
      oneof: "message_type",
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ChatMessage {
    return new ChatMessage().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ChatMessage {
    return new ChatMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ChatMessage {
    return new ChatMessage().fromJsonString(jsonString, options);
  }

  static equals(
    a: ChatMessage | PlainMessage<ChatMessage> | undefined,
    b: ChatMessage | PlainMessage<ChatMessage> | undefined,
  ): boolean {
    return proto3.util.equals(ChatMessage, a, b);
  }
}

/**
 * @generated from message context_engine.ChatGeneration
 */
export class ChatGeneration extends Message<ChatGeneration> {
  /**
   * @generated from field: context_engine.ChatMessage chat_message = 1;
   */
  chatMessage?: ChatMessage;

  constructor(data?: PartialMessage<ChatGeneration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ChatGeneration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chat_message", kind: "message", T: ChatMessage },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ChatGeneration {
    return new ChatGeneration().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ChatGeneration {
    return new ChatGeneration().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ChatGeneration {
    return new ChatGeneration().fromJsonString(jsonString, options);
  }

  static equals(
    a: ChatGeneration | PlainMessage<ChatGeneration> | undefined,
    b: ChatGeneration | PlainMessage<ChatGeneration> | undefined,
  ): boolean {
    return proto3.util.equals(ChatGeneration, a, b);
  }
}

/**
 * @generated from message context_engine.ChatResult
 */
export class ChatResult extends Message<ChatResult> {
  /**
   * @generated from field: repeated context_engine.ChatGeneration generations = 1;
   */
  generations: ChatGeneration[] = [];

  constructor(data?: PartialMessage<ChatResult>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ChatResult";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "generations",
      kind: "message",
      T: ChatGeneration,
      repeated: true,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ChatResult {
    return new ChatResult().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ChatResult {
    return new ChatResult().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ChatResult {
    return new ChatResult().fromJsonString(jsonString, options);
  }

  static equals(
    a: ChatResult | PlainMessage<ChatResult> | undefined,
    b: ChatResult | PlainMessage<ChatResult> | undefined,
  ): boolean {
    return proto3.util.equals(ChatResult, a, b);
  }
}
